import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CK_EDITOR_CONFIG } from 'libs/shared/src/lib/constants';
import { CustomModalService } from 'libs/shared/src/lib/modal/custom-modal.service';

@Component({
  selector: 'piqet-angular-mail-sender',
  templateUrl: './mail-sender.component.html',
  styleUrls: ['./mail-sender.component.scss'],
})
export class MailSenderComponent {
  mailForm!: FormGroup;
  body: string = '';
  ckEditorConfig = CK_EDITOR_CONFIG;
  toMail: any;

  constructor(private fb: FormBuilder, private modal: CustomModalService) {
    this.toMail = this.modal?.modalService?.config?.initialState?.['mail'];
  }

  ngOnInit(): void {
    this.mailForm = this.fb.group({
      from: ['', [Validators.required, Validators.email]],
      to: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required],
      body: ['', Validators.required],
    });

    this.patchFormValue();
  }

  patchFormValue() {
    if (this.toMail) {
      this.mailForm.patchValue({
        to: this.toMail,
      });
    }
  }

  onSend(): void {
    if (this.mailForm.valid) {
      const mailData = this.mailForm.value;
    }
  }

  onClose(): void {
    this.modal.close();
  }
}
